/**
 * The chat's display limits and naming constants, in one place. A limit the BFF contract also has
 * (`MAX_COMPETITOR_PICKS`) is read from the contract, never copied.
 */
import { MAX_COMPETITOR_PICKS } from '@/contracts/onboarding-session';

/** The most competitors the person can confirm: the contract's cap (the PUT rejects more), shown in the copy and enforced by the panel. */
export const COMPETITOR_PICKS_MAX = MAX_COMPETITOR_PICKS;

/**
 * The brand profile kept in the browser session. These bound what is stored (and what a stored session may hold when
 * it is read back). A product name is cut shorter than the contract's `MAX_PRODUCT_NAME_LENGTH` the site may send.
 */
export const BRAND_PROFILE_LIMITS = { products: 24, productLength: 80, text: 500 } as const;

/** The products selected from the start: the first few the brand guide lists (its top sellers first). */
export const DEFAULT_SELECTED_PRODUCTS = 3;
/** The most listed product chips the brand profile draws (the site can list far more); never above what the profile stores. */
export const PRODUCT_CHIPS_SHOWN = 12;

/** How many of the site's own products the brand guide's Products row names; the rest read "+ N more". */
export const GUIDE_PRODUCTS_SHOWN = 6;

/** How many ads the ads card draws; its live count still counts them all. */
export const ADS_SHOWN = 6;

/** How many of the newest top-level research steps show; the rest sit behind "N earlier steps". */
export const RESEARCH_VISIBLE_TAIL = 3;

/**
 * The last resort for a brand's name, when neither the research nor the brand guide has read one: the registrable
 * label of the site's address. The generic second levels that sit before a country code (`co.uk`, `com.au`)...
 */
export const COMPOUND_SECOND_LEVELS: readonly string[] = ['co', 'com', 'org', 'net', 'gov', 'ac', 'edu'];
/** ...and a country-code top-level domain is this many letters. */
export const COUNTRY_CODE_LENGTH = 2;
